import { useSnackbar } from 'notistack';

import { type RessourcenBlockungen, type Veranstaltung, type Zeitraum } from '../../dtos';
import { queryClient, trpc } from '../../trpc';
import { isOnlineVeranstaltung } from '../../utils';

type VeranstaltungForRessourcenUpdate = Pick<Veranstaltung, 'akaVeranstaltungId' | 'onlineTool'>;

export function useUpdateRessourcenBlockungenOfVeranstaltung(veranstaltung: VeranstaltungForRessourcenUpdate) {
  const { enqueueSnackbar } = useSnackbar();

  const resourceMutation = trpc.veranstaltung.updateRessourcenBlockungenOfVeranstaltung.useMutation({
    onError: () => {
      enqueueSnackbar('Speichern der Ressourcen fehlgeschlagen.', { variant: 'error', persist: true });
    },
  });

  const save = async (ressourcenBlockungen: RessourcenBlockungen, ablauf: Zeitraum[]): Promise<void> => {
    await resourceMutation.mutateAsync({
      akaVeranstaltungId: veranstaltung.akaVeranstaltungId,
      blockungen: ressourcenBlockungen,
      isOnlineVeranstaltung: isOnlineVeranstaltung(veranstaltung),
      ablauf,
    });

    await queryClient.refetchQueries();
    enqueueSnackbar('Gespeichert', { variant: 'success' });
  };

  return {
    save,
    isPending: resourceMutation.isPending,
  };
}
